import { useEffect } from "react";
import Lenis from "lenis";
import { registerLenis, unregisterLenis } from "@/lib/smoothScroll";

/**
 * Global smooth momentum scrolling with lenis.
 * Mount once at the app root.
 */
export const SmoothScroll = () => {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 1.4,
        });

        // Route changes reset the scroll through this instance — see
        // lib/smoothScroll.js for why window.scrollTo is not enough.
        registerLenis(lenis);

        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        // Anchor navigation
        const onClick = (e) => {
            const target = e.target.closest("a[href^='#']");
            if (!target) return;
            const id = target.getAttribute("href");
            if (!id || id === "#") return;
            const el = document.querySelector(id);
            if (el) {
                e.preventDefault();
                lenis.resize();
                lenis.scrollTo(el, { offset: -100, duration: 1.2 });
            }
        };
        document.addEventListener("click", onClick);

        return () => {
            document.removeEventListener("click", onClick);
            cancelAnimationFrame(rafId);
            unregisterLenis();
            lenis.destroy();
        };
    }, []);

    return null;
};
